import { useMutation } from '@tanstack/react-query'
import { apiFetch } from './core'

/**
 * Client telemetry. Written by every view, read only by the admin usage
 * screens, so it belongs to neither: trackEvent used to live in api/admin.ts,
 * which made that 600-line admin module a dependency of ten files across
 * Focus, Table, Dashboard and Map, and left api/admin looking shared when in
 * fact only the admin feature needs the rest of it.
 */

/** Presence ping, so the admin user list can show who is online. */
export function useHeartbeat() {
  return useMutation({
    mutationKey: ['presence'],
    mutationFn: () => apiFetch<{ onlineCount: number }>('/api/heartbeat', { method: 'POST' }),
  })
}

// Fire-and-forget client usage event (time-on-tab, feature interactions).
// `keepalive` lets the final flush survive a tab close. Never throws.
export function trackEvent(event: string, metadata?: Record<string, unknown>, leadId?: string): void {
  try {
    void fetch('/api/track', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ event, metadata, leadId }),
      keepalive: true,
      credentials: 'same-origin',
    }).catch(() => { /* best-effort */ })
  } catch { /* ignore */ }
}
